// @flow

import * as React from 'react';
import classNames from 'classnames';
import Box from 'sail/Box';
import Group from 'sail/Group';
import './Table.scss';

type TableType = 'solid' | 'striped' | 'reference';

type TableProps = {|
  children: React.Node,
  type: TableType,
  fixed?: boolean,
  highlightCol?: number,
|};

export const Table = ({children, type, fixed, highlightCol}: TableProps) => (
  <Box
    padding={{vertical: 12}}
    className={classNames(
      'Table',
      `Table--${type}`,
      fixed && 'Table--fixed',
      !!highlightCol && 'Table--highlightCol',
    )}
  >
    <table>
      {highlightCol && (
        <colgroup>
          {highlightCol > 1 && <col span={highlightCol - 1} />}
          <col className="Highlight-col" />
        </colgroup>
      )}
      {children}
    </table>
  </Box>
);

type TableHeaderCellProps = {|
  className?: string,
  id?: string,
  children?: React.Node,
  colspan?: number,
  width?: number,
  align?: string,
|};

export const TableHeaderCell = ({
  className,
  id,
  children,
  colspan,
  align,
  width,
}: TableHeaderCellProps) => (
  <th
    id={id}
    className={className}
    style={{textAlign: align}}
    width={width ? `${width}%` : undefined}
    colSpan={colspan}
  >
    <Group direction="horizontal" alignItems="center">
      {children}
    </Group>
  </th>
);

type TableCellProps = {|
  className?: string,
  id?: string,
  children?: React.Node,
  colspan?: number,
  rowspan?: number,
  align?: string,
|};

export const TableCell = ({
  className,
  id,
  children,
  align,
  colspan,
  rowspan,
}: TableCellProps) => (
  <td
    id={id}
    className={className}
    style={{textAlign: align}}
    colSpan={colspan}
    rowSpan={rowspan}
  >
    {children}
  </td>
);
